const formatNumber = (locale, value) => {
  if (locale === 'it') {
    return new Intl.NumberFormat('it-IT').format(value);
  }

  return new Intl.NumberFormat('en-US').format(value);
};

export default formatNumber;
